import "./newMessageModal.css";
import { BsX } from "react-icons/bs";
import { IoIosAttach } from "react-icons/io";
import RichTextEditor, { EditorValue } from "react-rte";
import { useEffect, useMemo, useRef, useState } from "react";
import RecipientsSearchModal from "../recipientsSearchModal/RecipientsSearchModal";
// import { recipientsData } from "../../../../utils/constants";
import { RecipientType } from "../../../../types/message";
// import { ChangeEvent } from "../../../../types/event-types";
import { Modal } from "react-bootstrap";
import DraggableModalDialog from "../../../draggable-modal/DraggableModalDialog";
import { w3cwebsocket as Socket } from "websocket";
import { useAppContext } from "../../../../context/app-context";
import { PaginatedApiResponseType } from "../../../../types/common";
import useData from "../../../../hooks/use-data";
import { toast } from "react-toastify";
// import moment from "moment";
// import { apiPaths } from "../../../../api/api-paths";

// interface Props {
//   hideNewMessageModal: () => void;
// }
type Props = {
  show: boolean;
  onHide: () => void;
  setShowMessages: (e: boolean) => void;
  setMessages: (e: any) => void;
  refetch: () => void;
  messageDetails?: any;
  showMessages?: boolean;
};

function NewMessageModal({
  show,
  onHide,
  setShowMessages,
  setMessages,
  refetch,
  messageDetails,
  showMessages,
}: Props) {
  const [editorValue, setEditorValue] = useState(EditorValue.createEmpty());
  const [searchRecipients, setSearchRecipients] = useState<
    RecipientType[] | undefined
  >([]);
  const [selectedRecipients, setSelectedRecipients] = useState<string[]>([]);
  const [recipientInput, setRecipientInput] = useState("");
  const [subjectInput, setSubjectInput] = useState("");
  const [selectedFiles, setSelectedFiles] = useState<
    { file: File; name: string }[] | undefined
  >();
  const { user } = useAppContext();

  const inputRef = useRef<HTMLInputElement | null>(null);
  const wsClient = useRef<Socket | null>(null);

  useEffect(() => {
    const connect = () => {
      wsClient.current = new Socket(
        "wss://api-dashboard.nautilusassure.io/chatall"
      );

      // eslint-disable-next-line unicorn/prefer-add-event-listener
      wsClient.current.onopen = () => {
        console.log("Connected to WebSocket server");
      };

      // eslint-disable-next-line unicorn/prefer-add-event-listener
      wsClient.current.onmessage = (event: any) => {
        const newMessage = JSON.parse(event.data);
        console.log("newMessagenewMessage", newMessage);
        setMessages((prevMessages: any[]) => [...prevMessages, newMessage]);
      };

      // eslint-disable-next-line unicorn/prefer-add-event-listener
      wsClient.current.onclose = () => {
        console.log("WebSocket closed. Reconnecting...");
        setTimeout(connect, 3000); // Attempt to reconnect after 3 seconds
      };
    };

    connect();

    return () => {
      wsClient.current?.close();
    };
  }, [show]);

  useEffect(() => {
    if (messageDetails?._id) {
      setSelectedRecipients(
        user?.email ===
          messageDetails?.messages[messageDetails?.messages?.length - 1]?.from
          ? messageDetails?.messages[messageDetails?.messages?.length - 1]?.to
          : [
              messageDetails?.messages[messageDetails?.messages?.length - 1]
                ?.from,
              ...messageDetails?.messages[
                messageDetails?.messages?.length - 1
              ]?.to.filter((item: any) => item !== user?.email),
            ]
      );
      setSubjectInput(messageDetails?.sub);
    }
  }, [messageDetails]);

  const params = useMemo(
    () => ({
      params: {
        role: ["nautilus-user", "nautilus-admin", "super-admin"],
        companyName: user?.attributes?.companyName[0],
      },
    }),
    []
  );

  const { data } = useData<PaginatedApiResponseType<RecipientType[]>>(
    `https://api-dashboard.nautilusassure.io/v1/keycloak/user`,
    {
      options: params,
      onError: () => {
        toast("Somthing went wrong", {
          type: "error",
        });
      },
    }
  );

  const handleRecipientInputChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRecipientInput(e.target.value);
    if (e.target.value) {
      const searchedRecipients: RecipientType[] | undefined =
        data?.data?.filter(
          (item) =>
            (item.username.trim().toLowerCase().includes(e.target.value) ||
              item.email.trim().toLowerCase().includes(e.target.value)) &&
            !selectedRecipients?.find((el) => el === item?.email)
        );
      setSearchRecipients(searchedRecipients);
    } else {
      setSearchRecipients([]);
    }
  };

  const sendMessage = async (
    msg: any,
    sub: string,
    docs: { file: File; name: string }[] | undefined,
    recipient: string[]
  ) => {
    const fileDataPromises = docs?.map(
      ({ file, name }) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();

          reader.addEventListener("load", () =>
            resolve({ data: reader.result, name })
          );

          reader.addEventListener("error", (error) => {
            console.error("Error reading file:", error);
            reject(error);
          });

          reader.readAsDataURL(file);
        })
    );
    const fileData = await Promise.all(fileDataPromises || []);

    if (wsClient.current?.readyState === WebSocket.OPEN) {
      if (messageDetails?._id) {
        wsClient.current.send(
          JSON.stringify({
            _id: messageDetails?._id,
            isRead: false,
            sub,
            sender: user?.email,
            dateTime: new Date().toISOString(),
            messages: [
              {
                msg: msg.toString("html"),
                docs: fileData,
                from: user?.email,
                userName: `${user?.firstName} ${user?.lastName}`,
                to: recipient,
                timestamp: new Date().toISOString(),
              },
            ],
          })
        );
      } else {
        wsClient.current.send(
          JSON.stringify({
            isRead: false,
            sub,
            sender: user?.email,
            dateTime: new Date().toISOString(),
            messages: [
              {
                msg: msg.toString("html"),
                docs: fileData,
                from: user?.email,
                userName: `${user?.firstName} ${user?.lastName}`,
                to: recipient,
                timestamp: new Date().toISOString(),
              },
            ],
          })
        );
      }
    } else {
      console.log("WebSocket connection is not open. Message not sent.");
    }
  };

  const handleEditorChange = (value: any) => {
    setEditorValue(value);
  };

  const addRecipient = (recipient: RecipientType) => {
    setSelectedRecipients([...selectedRecipients, recipient?.email]);
    setSearchRecipients([]);
    setRecipientInput("");
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const removeRecipient = (recipient: string) => {
    const newRecipients = selectedRecipients.filter(
      (item) => item !== recipient
    );
    setSelectedRecipients(newRecipients);
  };

  const handleKeyDown = (e: any) => {
    if (
      e.key === "Backspace" &&
      e.target.value === "" &&
      selectedRecipients.length > 0
    ) {
      const lastUser = selectedRecipients.at(-1);
      if (lastUser) {
        removeRecipient(lastUser);
      }
      setSearchRecipients([]);
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;

    if (files) {
      const filesArray: { file: File; name: string }[] = [...files].map(
        (file) => ({
          file,
          name: file.name,
        })
      );

      // Optional: Add any validation for file types, sizes, etc.
      const validFiles = filesArray.filter((item) => {
        // Example validation: only accept images and PDFs
        return (
          item.file.type.startsWith("image/") ||
          item.file.type === "application/pdf"
        );
      });

      setSelectedFiles(validFiles); // Store both file and name

      if (validFiles.length !== filesArray.length) {
        console.log("Some files were not accepted due to invalid file type.");
      }
    } else {
      console.log("No files were selected.");
    }
  };

  // const handleFileChange = (e: ChangeEvent) => {
  //   if (e.target.files) {
  //     const files: FileList = e.target.files;
  //     const filesArray: File[] = [...files];
  //     setSelectedFiles(filesArray);
  //   }
  // };

  const handleDeleteFile = (fileIndex: number) => {
    setSelectedFiles((prevFiles) =>
      prevFiles?.filter((item) => fileIndex !== prevFiles?.indexOf(item))
    );
  };

  useEffect(() => {
    if (showMessages) {
      setEditorValue(EditorValue.createEmpty());
      setSelectedRecipients([]);
      setSubjectInput("");
      setSelectedFiles([]);
    }
  }, [show]);

  return (
    <Modal
      show={show}
      dialogAs={DraggableModalDialog}
      onHide={onHide}
      className="send-message"
    >
      <Modal.Header closeButton>
        <Modal.Title>New Message</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center d-flex flex-column align-items-center">
        <div className="newMessageModal">
          <div className="w-100">
            <div className="d-flex align-items-center selectedRecipients gap-1 flex-wrap p-1">
              {selectedRecipients &&
                selectedRecipients.length > 0 &&
                selectedRecipients.map((item) => (
                  <div
                    key={item}
                    className="d-flex align-items-center gap-2 selectedRecipient"
                  >
                    <div>{item}</div>
                    <BsX
                      className="icon"
                      onClick={() => removeRecipient(item)}
                    />
                  </div>
                ))}
              <input
                ref={inputRef}
                type="text"
                placeholder="Recipients"
                value={recipientInput}
                className="border-0 outline-none inputText"
                onChange={(e) => handleRecipientInputChange(e)}
                onKeyDown={handleKeyDown}
              />
            </div>

            <input
              type="text"
              placeholder="Subject"
              value={subjectInput}
              className="w-100 border-0 outline-none inputText"
              onChange={(e) => setSubjectInput(e.target.value)}
            />
            <RichTextEditor
              value={editorValue}
              onChange={handleEditorChange}
              className="editor"
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {selectedFiles && selectedFiles.length > 0 && (
          <div className="w-100 d-flex flex-wrap">
            {selectedFiles.map((item, index) => (
              <div
                key={item?.name}
                className="d-flex gap-5 justify-content-between align-items-center selectedFile"
              >
                <p>{item?.name}</p>
                <BsX className="icon" onClick={() => handleDeleteFile(index)} />
              </div>
            ))}
          </div>
        )}
        <div className="w-100 p-2">
          <div className="d-flex align-items-center gap-2">
            <button
              className="primary-button"
              onClick={() => {
                sendMessage(
                  editorValue,
                  subjectInput,
                  selectedFiles,
                  selectedRecipients
                );
                // refetch();
                setShowMessages(true);
                onHide();
              }}
              disabled={!(selectedRecipients?.length > 0 && subjectInput)}
            >
              Send
            </button>
            <div>
              <label htmlFor="file">
                <IoIosAttach className="bottomIcon" />
              </label>
              <input
                type="file"
                id="file"
                accept="image/jpeg, .pdf, .jpg, .png"
                multiple
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            </div>
          </div>
        </div>
        {Array.isArray(searchRecipients) && searchRecipients.length > 0 && (
          <RecipientsSearchModal
            searchRecipients={searchRecipients}
            addRecipient={addRecipient}
          />
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default NewMessageModal;
